// extracted by mini-css-extract-plugin
export var container = "bD_b";
export var feature = "bD_cy";
export var featureText = "bD_cz";
export var features = "bD_cw";
export var footer = "bD_cC";
export var footerText = "bD_cD";
export var icon = "bD_bw";
export var section = "bD_j";
export var text = "bD_ck";
export var title = "bD_g";
export var waveOne = "bD_q";
export var waveThree = "bD_cr";
export var waveTwo = "bD_n";
export var waves = "bD_cq";